import callApi from 'utils/callApi';

// Requests
export function requestFetchClaimMDInfo({ limit, offset }) {
  return callApi('claim_md/payers/search/', 'POST', {
    limit,
    offset,
  });
}

export function requestSearchClaimMDInfo({ limit, offset, filters }) {
  return callApi('claim_md/payers/search/', 'POST', {
    filters,
    sort_by: [
      {
        name: 'Payer Name',
        sort: 'asc',
      },
      {
        name: 'ID',
        sort: 'asc',
      },
    ],
    limit,
    offset,
  });
}



// WEBPACK FOOTER //
// ./src/redux/modules/claimMDInfo.js